module.exports = __webpack_public_path__ + "static/media/YB_GoodsPreloadBackground_Iocn@3x.0c9beb1a.png";